<!-- 首页快捷导航 -->
<template>
  <!-- 首页快捷导航 -->
  <aside class="pc-home-side-nav" :aria-label="$t('nav.quickNavigation')">
    <router-link
      :to="aiItem.to"
      class="pc-home-side-nav__ai-card side-nav-entry side-nav-link side-nav-ai"
    >
      <span class="side-nav-icon" aria-hidden="true">
        <img :src="aiItem.icon" alt="" />
      </span>
      <span>{{ displaySideLabel(aiItem) }}</span>
    </router-link>

    <nav class="pc-home-side-nav__card">
      <template v-for="item in primaryItems">
        <router-link
          v-if="item.to"
          :key="item.label"
          :to="item.to"
          class="side-nav-entry side-nav-link"
        >
          <span class="side-nav-icon" aria-hidden="true">
            <img class="side-nav-icon__default" :src="item.icon" alt="" />
            <img class="side-nav-icon__active" :src="item.activeIcon" alt="" />
          </span>
          <span>{{ displaySideLabel(item) }}</span>
        </router-link>
        <button
          v-else
          :key="item.label"
          class="side-nav-entry"
          :class="{
            'side-nav-featured': item.action === 'featured',
            'side-nav-visual': item.action === 'visual',
          }"
          type="button"
          :aria-disabled="item.action === 'visual' ? 'true' : null"
          @click="handlePrimaryItem(item)"
        >
          <span class="side-nav-icon" aria-hidden="true">
            <img class="side-nav-icon__default" :src="item.icon" alt="" />
            <img class="side-nav-icon__active" :src="item.activeIcon" alt="" />
          </span>
          <span>{{ displaySideLabel(item) }}</span>
        </button>
      </template>

      <div class="side-nav-customer-group">
        <button
          class="side-nav-entry side-nav-link side-nav-customer"
          type="button"
          @click="$store.commit('agentServiceUi/openGeneral')"
        >
          <span class="side-nav-icon" aria-hidden="true">
            <img :src="customerIcon" alt="" />
          </span>
          <!-- 客服 -->
          <span>{{ $t("common.agentService") }}</span>
        </button>
        <button
          class="side-nav-entry side-nav-wechat"
          type="button"
          aria-disabled="true"
        >
          <i class="el-icon-chat-dot-round" aria-hidden="true"></i>
          <!-- 微信 -->
          <span>{{ $t("common.wechat") }}</span>
        </button>
      </div>
    </nav>

    <!-- 回到顶部 -->
    <button
      class="pc-home-side-nav__back-card"
      type="button"
      :aria-label="$t('common.backToTop')"
      @click="$emit('back-top')"
    >
      <i class="el-icon-top" aria-hidden="true"></i>
      <!-- 回到顶部 -->
      <span>{{ $t("common.backToTop") }}</span>
    </button>
  </aside>
</template>

<script>
import { navigationMessageKey } from "@/i18n/catalog";
import sideNavAi from "../assets/side-nav/side-nav-ai.png";
import sideNavBid from "../assets/side-nav/side-nav-bid.png";
import sideNavBidActive from "../assets/side-nav/side-nav-bid-active.png";
import sideNavCustomer from "../assets/side-nav/side-nav-customer.png";
import sideNavFeatured from "../assets/side-nav/side-nav-featured.png";
import sideNavFeaturedActive from "../assets/side-nav/side-nav-featured-active.png";
import sideNavMine from "../assets/side-nav/side-nav-mine.png";
import sideNavMineActive from "../assets/side-nav/side-nav-mine-active.png";
import sideNavNews from "../assets/side-nav/side-nav-news.png";
import sideNavNewsActive from "../assets/side-nav/side-nav-news-active.png";
import sideNavSelfOperated from "../assets/side-nav/side-nav-self-operated.png";
import sideNavSelfOperatedActive from "../assets/side-nav/side-nav-self-operated-active.png";
import sideNavSupply from "../assets/side-nav/side-nav-supply.png";
import sideNavSupplyActive from "../assets/side-nav/side-nav-supply-active.png";
import sideNavWiki from "../assets/side-nav/side-nav-wiki.png";
import sideNavWikiActive from "../assets/side-nav/side-nav-wiki-active.png";

export default {
  name: "PcHomeSideNav",
  data() {
    return {
      customerIcon: sideNavCustomer,
      aiItem: {
        label: "先搜AI",
        icon: sideNavAi,
        to: "/pc/myAi",
      },
      primaryItems: [
        {
          label: "精选",
          icon: sideNavFeatured,
          activeIcon: sideNavFeaturedActive,
          action: "featured",
        },
        {
          label: "竞标",
          icon: sideNavBid,
          activeIcon: sideNavBidActive,
          to: "/pc/bid",
        },
        {
          label: "供需",
          icon: sideNavSupply,
          activeIcon: sideNavSupplyActive,
          to: "/pc/clue",
        },
        {
          label: "百科",
          icon: sideNavWiki,
          activeIcon: sideNavWikiActive,
          to: "/pc/wiki",
        },
        {
          label: "我的",
          icon: sideNavMine,
          activeIcon: sideNavMineActive,
          to: "/pc/myxg",
        },
        {
          label: "自营",
          icon: sideNavSelfOperated,
          activeIcon: sideNavSelfOperatedActive,
          action: "visual",
        },
        {
          label: "资讯",
          icon: sideNavNews,
          activeIcon: sideNavNewsActive,
          to: { path: "/pc/about", query: { section: "contact" } },
        },
      ],
    };
  },
  methods: {
    displaySideLabel(item) {
      const key =
        item.action === "featured"
          ? "nav.featured"
          : item.action === "visual"
          ? "nav.selfOperated"
          : navigationMessageKey(
              typeof item.to === "string" ? item.to : item.to?.path
            );
      // 动态简中示例：按 navigationMessageKey 的路由／标题映射取词；未知导航保留原名；完整中文见对应 zh-CN.js，示例不代表固定返回值
      // nav.home：首页
      // nav.publish：发布
      // nav.featured：精选
      // nav.bidding：竞标
      // nav.supply：供需
      // nav.wiki：百科
      return key ? this.$t(key) : item.label;
    },
    handlePrimaryItem(item) {
      if (item.action === "featured") {
        this.$emit("select-featured");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.pc-home-side-nav {
  position: fixed;
  top: 50%;
  right: 24px;
  z-index: 30;
  width: 68px;
  transform: translateY(-50%);

  .pc-home-side-nav__card,
  .pc-home-side-nav__ai-card,
  .pc-home-side-nav__back-card {
    box-sizing: border-box;
    width: 100%;
    border: 0;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 12px 34px rgba(45, 64, 92, 0.12);
    backdrop-filter: blur(12px);
  }

  .pc-home-side-nav__card {
    overflow: hidden;
    padding: 5px 0;
    border-radius: 14px;
  }

  .side-nav-entry {
    width: 100%;
    min-height: 56px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    box-sizing: border-box;
    padding: 6px 4px;
    border: 0;
    outline: 0;
    background: transparent;
    color: #929cab;
    font-family: inherit;
    font-size: 10px;
    line-height: 17px;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.2s ease, background-color 0.2s ease;

    .side-nav-icon {
      position: relative;
      width: 22px;
      height: 22px;
      flex: 0 0 22px;
      transition: transform 0.2s ease;

      img {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
        opacity: 0;
        transition: opacity 0.2s ease;

        &.side-nav-icon__default,
        &:only-child {
          opacity: 0.58;
        }
      }
    }

    &:hover,
    &:focus-visible {
      background: rgba(66, 134, 245, 0.08);
      color: #3479e4;

      .side-nav-icon {
        transform: translateY(-1px);

        .side-nav-icon__default {
          opacity: 0;
        }

        .side-nav-icon__active {
          opacity: 1;
        }
      }
    }

    &:focus-visible {
      box-shadow: inset 0 0 0 2px rgba(66, 134, 245, 0.28);
    }

    &.router-link-active,
    &.side-nav-featured {
      color: #3479e4;

      .side-nav-icon {
        .side-nav-icon__default {
          opacity: 0;
        }

        .side-nav-icon__active {
          opacity: 1;
        }
      }
    }
  }

  .pc-home-side-nav__ai-card {
    min-height: 64px;
    margin-bottom: 10px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.96);
    color: #3479e4;

    .side-nav-icon {
      width: 28px;
      height: 28px;
      flex-basis: 28px;

      img:only-child {
        opacity: 1;
      }
    }

    &:hover,
    &:focus-visible,
    &.router-link-active {
      background: rgba(255, 255, 255, 0.96);
      color: #3479e4;
    }
  }

  .side-nav-customer-group {
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 0;
    background: transparent;

    .side-nav-wechat {
      color: #9aa4b2;
      cursor: default;

      &:hover,
      &:focus-visible {
        background: transparent;
        color: #9aa4b2;
        box-shadow: none;

        .side-nav-icon {
          transform: none;
        }
      }
    }

    .side-nav-customer {
      color: inherit;
      cursor: pointer;

      &:hover,
      &:focus-visible {
        background: rgba(66, 134, 245, 0.08);
        color: #3479e4;
      }
    }

    .side-nav-wechat {
      width: 100%;
      min-height: 38px;
      margin: 0;
      padding: 0 3px 4px;
      flex-direction: column;
      gap: 1px;
      border: 0;
      border-radius: 0 0 8px 8px;
      font-size: 10px;
      line-height: 13px;

      i {
        font-size: 18px;
      }
    }
  }

  .pc-home-side-nav__back-card {
    height: 52px;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    padding: 5px 2px;
    border-radius: 12px;
    color: #919baa;
    font-family: inherit;
    font-size: 10px;
    line-height: 16px;
    cursor: pointer;
    transition: color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;

    i {
      color: #9da6b3;
      font-size: 18px;
      transition: color 0.2s ease;
    }

    &:hover,
    &:focus-visible {
      color: #7f8998;
      box-shadow: 0 14px 34px rgba(45, 64, 92, 0.16);
      transform: translateY(-2px);

      i {
        color: #87919f;
      }
    }

    &:focus-visible {
      outline: 2px solid rgba(95, 106, 121, 0.24);
      outline-offset: 2px;
    }
  }

  @media (max-width: 1280px) {
    right: 12px;
    width: 60px;

    .side-nav-entry {
      font-size: 10px;
    }
  }

  @media (max-height: 760px) {
    .pc-home-side-nav__ai-card.side-nav-entry {
      min-height: 58px;

      .side-nav-icon {
        width: 26px;
        height: 26px;
        flex-basis: 26px;
      }
    }

    .pc-home-side-nav__card {
      padding: 4px 0;
    }

    .side-nav-entry {
      min-height: 51px;
      padding: 4px 3px;

      .side-nav-icon {
        width: 22px;
        height: 22px;
        flex-basis: 22px;
      }
    }

    .side-nav-customer-group {
      .side-nav-wechat {
        min-height: 36px;

        i {
          font-size: 16px;
        }
      }
    }

    .pc-home-side-nav__back-card {
      height: 46px;
      margin-top: 8px;
    }
  }
}
</style>
